import { useRuntimeConfig } from '#imports';
import { authUserHeaders } from 'r3ui-lib';
import { apiFetch } from '~/utils/apiFetch';

export async function fetchAuthUser(token: string): Promise<unknown> {
  const config = useRuntimeConfig();
  return apiFetch(`${config.public.apiUrl}/api/services/auth/user`, {
    headers: authUserHeaders(token),
  });
}

export async function logOutSSO(): Promise<unknown> {
  return $fetch('/api/auth/logout', { method: 'POST' });
}
